import * as React from "react";
import { useState } from "react";
import { Button, BootstrapModalForm, Input } from "components/bootstrap";
import { IfPermitted } from "components/common";
import ObjectUtils from "util/ObjectUtils";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const defaultConfig = {
  tor_enabled: false,
  spamhaus_enabled: false
};
const ThreatIntelPluginConfig = ({ config: initialConfig = defaultConfig, updateConfig }) => {
  const [showModal, setShowModal] = useState(false);
  const [config, setConfig] = useState(ObjectUtils.clone(initialConfig));
  const sendTelemetry = useSendTelemetry("threat-intel");
  const _updateConfigField = (field, value) => {
    const newConfig = {
      ...config,
      [field]: value
    };
    setConfig(newConfig);
  };
  const _onCheckboxClick = (e) => {
    _updateConfigField(e.target.name, e.target.checked);
  };
  const _openModal = () => {
    setShowModal(true);
  };
  const _closeModal = () => {
    setShowModal(false);
  };
  const _resetConfig = () => {
    setConfig(initialConfig);
    _closeModal();
  };
  const _saveConfig = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CONFIGURATIONS.THREATINTEL_CONFIGURATION_UPDATED, {
      app_pathname: "configurations"
    });
    updateConfig(config).then(() => {
      _closeModal();
    });
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", null, "Threat Intelligence Lookup Configuration"), /* @__PURE__ */ React.createElement("p", null, "Configuration for threat intelligence lookup plugin."), /* @__PURE__ */ React.createElement("dl", { className: "deflist" }, /* @__PURE__ */ React.createElement("dt", null, "Tor exit nodes:"), /* @__PURE__ */ React.createElement("dd", null, config.tor_enabled === true ? "Enabled" : "Disabled"), /* @__PURE__ */ React.createElement("dt", null, "Spamhaus:"), /* @__PURE__ */ React.createElement("dd", null, config.spamhaus_enabled === true ? "Enabled" : "Disabled")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", onClick: _openModal }, "Edit configuration")), /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: showModal,
      title: "Update Threat Intelligence plugin Configuration",
      onSubmitForm: _saveConfig,
      onCancel: _resetConfig,
      submitButtonText: "Update configuration"
    },
    /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "checkbox",
        id: "tor-checkbox",
        label: "Allow Tor exit node lookups?",
        help: "Enable to include Tor exit node lookup in global pipeline function, disabling also stops refreshing the data.",
        name: "tor_enabled",
        checked: config.tor_enabled,
        onChange: _onCheckboxClick
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "checkbox",
        id: "spamhaus-checkbox",
        label: "Allow Spamhaus DROP/EDROP lookups?",
        help: "Enable to include Spamhaus lookup in global pipeline function, disabling also stops refreshing the data.",
        name: "spamhaus_enabled",
        checked: config.spamhaus_enabled,
        onChange: _onCheckboxClick
      }
    ))
  ));
};
export default ThreatIntelPluginConfig;
